import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

export class PassportScanController extends Controller {
  static targets = ['notice']
  static values = { url: String, types: Array }

  async scan (event) {
    if (!event.target.matches('[data-file-input-target="hiddenInput"]')) return

    this.request?.abort()
    this.noticeTarget.hidden = true
    const file = event.target.files?.[0]
    if (!file) return
    if (!this.typesValue.includes(file.type)) {
      this.noticeTarget.hidden = false
      return
    }

    this.request = new AbortController()
    // A scan takes seconds; whatever the guest types meanwhile wins over the scan.
    const valuesAtPick = new Map([...(this.element.closest('form')?.elements || [])].map((field) => [field, field.value]))
    const body = new FormData()
    body.append('file', file)

    try {
      const response = await fetch(this.urlValue, { method: 'POST', body, signal: this.request.signal })
      if (response.status === 422) {
        this.noticeTarget.hidden = false
        return
      }
      if (!response.ok) throw new Error(`HTTP ${response.status}`)

      const values = await response.json()
      Object.entries(values).forEach(([sqid, value]) => this.#fill(sqid, value, valuesAtPick))
    } catch (error) {
      if (error.name === 'AbortError') return

      this.noticeTarget.hidden = false
      console.error('Passport scan failed:', error)
    }
  }

  disconnect () {
    this.request?.abort()
  }

  #fill (sqid, value, valuesAtPick) {
    const form = this.element.closest('form')
    const marker = form?.querySelector(`input[type="hidden"][value="${window.CSS.escape(sqid)}"][name$="[webform_element]"]`)
    const input = marker && form.querySelector(`[name="${window.CSS.escape(marker.name.replace('[webform_element]', '[value]'))}"]`)
    if (!input || input.value !== valuesAtPick.get(input)) return

    const field = input.matches('[data-controller~="easepick"]') ? this.#replaceDateInput(input, value) : input
    field.value = value
    field.closest('.form__group')?.classList.remove('form__group-errored')
    field.closest('.form__group')?.querySelector('.form__error')?.remove()
    field.dispatchEvent(new Event('change', { bubbles: true }))
  }

  // The date picker builds itself from its input's value when it connects, so a fresh input
  // makes it rebuild from the scanned date instead of keeping the old one.
  #replaceDateInput (input, value) {
    const fresh = input.cloneNode()
    fresh.value = value
    input.replaceWith(fresh)
    return fresh
  }
}

stimulus.register('passport-scan', PassportScanController)
